import React from "react";
import { Btn } from "@/components/UI";
import { ShoppingCart, ExternalLink } from "lucide-react";
import { fmtQty } from "@/lib/products";
import { MaterialStatus } from "@/components/materials/MaterialStatus";

const HEAD = ["Ürün", "Malzeme", "Tür", "Kullanım", "Mevcut Stok", "Kritik Stok", "Durum", "Varsayılan Tedarikçi", "İşlem"];

// Ürün bazlı gruplu tablo: ürün hücresi rowSpan ile malzeme satırları boyunca birleşir.
export function MaterialStockTable({ groups, onGoProduct, onPurchase, canPurchase }) {
  if (!groups.length) return <div className="p-6 text-sm text-slate-500 text-center border rounded-xl" data-testid="material-stock-empty">Malzeme bulunamadı</div>;
  return (
    <div className="overflow-x-auto rounded-xl border border-slate-200 bg-white" data-testid="material-stock-table">
      <table className="w-full text-sm">
        <thead className="bg-slate-50 text-[11px] uppercase tracking-wider text-slate-500">
          <tr>{HEAD.map((h) => <th key={h} className="text-left px-3 py-2">{h}</th>)}</tr>
        </thead>
        {groups.map((g) => (
          <tbody key={g.product_id} className="border-t-4 border-slate-100" data-testid={`ms-group-${g.product_id}`}>
            {g.materials.map((m, i) => (
              <tr key={m.id} className={`border-t border-slate-100 hover:bg-slate-50/60 ${m.active ? "" : "opacity-50"}`} data-testid={`ms-row-${m.id}`}>
                {i === 0 && (
                  <td rowSpan={g.materials.length} className="px-3 py-2 align-top bg-slate-50/40 border-r border-slate-100" data-testid={`ms-product-${g.product_id}`}>
                    <div className="font-semibold">{g.product_name}</div><div className="font-mono text-[11px] text-slate-500">{g.product_code}</div>
                  </td>
                )}
                <td className="px-3 py-2 font-medium" data-testid={`ms-name-${m.id}`}>{m.name}{!m.active && <span className="ml-1 text-[10px] text-slate-500">(Pasif)</span>}</td>
                <td className="px-3 py-2">{m.material_type}</td>
                <td className="px-3 py-2 font-mono">{fmtQty(m.usage_qty)}</td>
                <td className={`px-3 py-2 font-mono font-semibold ${m.stock_qty < 0 ? "text-rose-700" : ""}`} data-testid={`ms-stock-${m.id}`}>{fmtQty(m.stock_qty)}</td>
                <td className="px-3 py-2 font-mono">{fmtQty(m.critical_stock)}</td>
                <td className="px-3 py-2"><MaterialStatus status={m.status} testid={`ms-status-${m.id}`} /></td>
                <td className="px-3 py-2 text-xs">{m.default_supplier_name || "—"}</td>
                <td className="px-3 py-2"><div className="flex gap-1">
                  <Btn size="sm" variant="ghost" onClick={() => onGoProduct(g.product_id)} data-testid={`ms-go-${m.id}`}><ExternalLink size={12} /> Ürüne Git</Btn>
                  {canPurchase && <Btn size="sm" variant={m.is_critical ? "warn" : "secondary"} onClick={() => onPurchase({ m, g })} data-testid={`ms-po-${m.id}`}><ShoppingCart size={12} /> Satın Alma Oluştur</Btn>}
                </div></td>
              </tr>
            ))}
          </tbody>
        ))}
      </table>
    </div>
  );
}
